<template>
  <div class="safe-page">
    <header class="safe-header">
      <button
        type="button"
        class="back-btn"
        @click="$router.go(-1)"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>
        {{ $t('safe.setting') }}
      </h1>
    </header>

    <main class="safe-main">
      <section class="profile-card">
        <div
          class="avatar-wrap"
          role="button"
          tabindex="0"
          @click="avatarPickerVisible = true"
          @keyup.enter="avatarPickerVisible = true"
        >
          <img
            :src="avatarSrc"
            alt=""
            @error="avatarError = true"
          >
          <span class="camera-badge">
            <van-icon name="photograph" />
          </span>
        </div>
        <div class="profile-info">
          <strong>{{ displayName }}</strong>
          <span>{{ $t('safe.setting') }}</span>
        </div>
        <van-icon
          class="profile-arrow"
          name="arrow"
        />
      </section>

      <section class="settings-card primary-card">
        <router-link
          to="/setpwd"
          class="setting-row"
        >
          <span class="setting-icon blue">
            <van-icon name="lock" />
          </span>
          <span class="setting-label">{{ $t('safe.signInPassword') }}</span>
          <van-icon
            class="row-arrow"
            name="arrow"
          />
        </router-link>
        <router-link
          to="/setpaypwd"
          class="setting-row"
        >
          <span class="setting-icon red">
            <van-icon name="shield-o" />
          </span>
          <span class="setting-label">{{ $t('safe.paymentPassword') }}</span>
          <van-icon
            class="row-arrow"
            name="arrow"
          />
        </router-link>
      </section>

      <section class="settings-card">
        <!--  <div class="setting-row">
          <span class="setting-icon violet">
            <van-icon name="certificate" />
          </span>
          <span class="setting-label">{{ $t('safe.verified') }}</span>
          <span
            v-if="data.is_auth == '1'"
            class="row-note"
          >
            {{ $t('safe.verifiedIdentity') }}
          </span>
          <router-link
            v-if="data.is_auth == '0'"
            to="/authEmail"
            class="row-note auth"
          >
            {{ $t('safe.toVerify') }}
          </router-link>
          <van-icon
            v-if="data.is_auth == '0'"
            class="row-arrow"
            name="arrow"
          />
        </div> -->
        <router-link
          to="/account"
          class="setting-row"
        >
          <span class="setting-icon cyan">
            <van-icon name="credit-pay" />
          </span>
          <span class="setting-label">{{ $t('safe.paymentOptions') }}</span>
          <van-icon
            class="row-arrow"
            name="arrow"
          />
        </router-link>
        <router-link
          to="/language"
          class="setting-row"
        >
          <span class="setting-icon green">
            <van-icon name="exchange" />
          </span>
          <span class="setting-label">{{ $t('safe.language') }}</span>
          <van-icon
            class="row-arrow"
            name="arrow"
          />
        </router-link>
        <router-link
          to="/about/27"
          class="setting-row"
        >
          <span class="setting-icon orange">
            <van-icon name="orders-o" />
          </span>
          <span class="setting-label">{{ $t('user.aboutUs') }}</span>
          <van-icon
            class="row-arrow"
            name="arrow"
          />
        </router-link>
        <router-link
          to="/about/38"
          class="setting-row"
        >
          <span class="setting-icon gray">
            <van-icon name="description" />
          </span>
          <span class="setting-label">{{ $t('index.agreement') }}</span>
          <van-icon
            class="row-arrow"
            name="arrow"
          />
        </router-link>
      </section>

      <button
        type="button"
        class="logout-btn"
        @click="logout"
      >
        {{ $t('safe.signOut') }}
      </button>
    </main>
    <avatar-picker
      v-model="avatarPickerVisible"
      :current-avatar="data.user_icon || ''"
      @updated="onAvatarUpdated"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import AvatarPicker from '../../components/AvatarPicker.vue';
import { Icon } from 'vant';

Vue.use(Icon);

export default {
  name: 'Safe',
  components: {
    AvatarPicker,
  },
  data() {
    return {
      data: {},
      avatarError: false,
      avatarPickerVisible: false,
      defaultAvatar: require('../images/home/headDefault.png'),
      appVer: '',
      wgtVer: '',
    };
  },
  computed: {
    displayName() {
      return this.data.name || this.data.mobile || '--';
    },
    avatarSrc() {
      if (this.avatarError) {
        return this.defaultAvatar;
      }
      return this.buildImageUrl(this.data.user_icon, this.defaultAvatar);
    },
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
    // this.getVersion();
  },
  methods: {
    start() {
      Fetch('/user/info').then((r) => {
        this.data = r.data;
        this.avatarError = false;
      });
    },
    buildImageUrl(path, fallback) {
      if (!path) {
        return fallback;
      }
      if (/^(https?:)?\/\//.test(path) || String(path).indexOf('data:') === 0) {
        return path;
      }
      return path;
    },
    onAvatarUpdated(icon) {
      this.$set(this.data, 'user_icon', icon);
      this.avatarError = false;
    },
    logout() {
      localStorage.removeItem('token');
      this.$router.replace('/');
    },
  },
};
</script>

<style lang="less" scoped>
.safe-page {
  min-height: 100vh;
  padding-bottom: 18px;
  box-sizing: border-box;
  background: #f4f5fb;
  color: #061429;
}

.safe-header {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fd;
}

.safe-header h1 {
  margin: 0;
  color: #202637;
  font-size: 14px;
  font-weight: 500;
  line-height: 58px;
}

.back-btn {
  position: absolute;
  left: 8px;
  top: 10px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #071426;
  font-size: 22px;
}

.safe-main {
  padding: 16px 16px 88px;
}

.profile-card,
.settings-card {
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
}

.profile-card {
  min-height: 108px;
  display: grid;
  grid-template-columns: 74px minmax(0, 1fr) 18px;
  align-items: center;
  padding: 14px 18px;
  box-sizing: border-box;
}

.avatar-wrap {
  position: relative;
  width: 68px;
  height: 68px;
}

.avatar-wrap img {
  display: block;
  width: 68px;
  height: 68px;
  padding: 6px;
  box-sizing: border-box;
  border-radius: 50%;
  object-fit: contain;
  background: #fff;
  box-shadow: 0 5px 14px rgba(39, 50, 73, .07);
}

.camera-badge {
  position: absolute;
  right: 0;
  bottom: 1px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff8d39 0%, #ff5048 100%);
  color: #fff;
  font-size: 10px;
  box-sizing: border-box;
}

.profile-info {
  min-width: 0;
  padding-left: 12px;
}

.profile-info strong {
  display: block;
  overflow: hidden;
  color: #050b18;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-info span {
  display: block;
  margin-top: 4px;
  color: #a4aab6;
  font-size: 12px;
  line-height: 18px;
}

.profile-arrow,
.row-arrow {
  color: #c4cad4;
  font-size: 16px;
}

.row-arrow {
  grid-column: 4;
}

.settings-card {
  margin-top: 18px;
}

.primary-card {
  margin-top: 18px;
}

.setting-row {
  min-height: 70px;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto 16px;
  align-items: center;
  column-gap: 14px;
  margin: 0 20px;
  border-bottom: 1px solid #edf0f6;
  color: #1f2b44;
  text-decoration: none;
  box-sizing: border-box;
}

.setting-row:last-child {
  border-bottom: 0;
}

.setting-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
}

.setting-icon.blue {
  background: linear-gradient(135deg, #6199ff 0%, #246cf2 100%);
}

.setting-icon.red {
  background: linear-gradient(135deg, #ff6764 0%, #ff3346 100%);
}

.setting-icon.violet {
  background: linear-gradient(135deg, #9a86ff 0%, #7662f7 100%);
}

.setting-icon.cyan {
  background: linear-gradient(135deg, #42d7dc 0%, #17a8cc 100%);
}

.setting-icon.green {
  background: linear-gradient(135deg, #70d87b 0%, #2fac59 100%);
}

.setting-icon.orange {
  background: linear-gradient(135deg, #ffbd61 0%, #ff8e2b 100%);
}

.setting-icon.gray {
  background: linear-gradient(135deg, #a8b2c1 0%, #737f91 100%);
}

.setting-label {
  min-width: 0;
  overflow: hidden;
  color: #243049;
  font-size: 14px;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-note {
  max-width: 112px;
  overflow: hidden;
  color: #9aa2b1;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-note.auth {
  color: #3775f4;
  font-weight: 500;
  text-decoration: none;
}

.logout-btn {
  width: 100%;
  height: 42px;
  margin-top: 22px;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
  color: #ff4551;
  font-size: 14px;
  font-weight: 500;
}
</style>
